/**
 * Current reducer
 * Source of truth for tab & components
 */
import { helpers, ITicker } from '@kattana-io/common';
import { SWITCH } from '../actions/current';
import { KTN_TOKEN_ADDRESS } from '../helpers/constants';

export interface ICurrentState extends ITicker {
  base_precision: number;
  base: string;
  quote: string;
  new?: boolean;
}

const KTNState: ICurrentState = {
  id: 79970,
  name: 'KTN/WETH',
  chain: 'ETH',
  address: '0x92dBB765f587F6E16C07C799E0dB6A1f3AF498B8',
  base_address: KTN_TOKEN_ADDRESS,
  base_decimals: 18,
  quote_address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  quote_decimals: 18,
  exchange: helpers.exchanges.UNISWAP,
  flipped: false,
  rank: 6,
  kind: 2,
  pool_created: 1617978503,
  base_id: 4319,
  quote_id: 32,
  price_a: 0,
  price_a_usd: 0,
  price_b: 0,
  price_b_usd: 0,
  liquidity: 0,
  volume: 0,
  base_reserve: 0,
  quote_reserve: 0,
  updated_at: 0,
  annual_percentage_yield: 0,
  base: 'KTN',
  quote: 'WETH',
  base_precision: 2,
  change_a: 0,
  change_a_usd: 0,
  change_b: 0,
  change_b_usd: 0,
  new: true,
};

/**
 * Application backend puts ticker object so we can optimize initial loading and avoid query
 * @returns ICurrentState
 */
export const getDefaultState = (): ICurrentState => {
  if ((window as any).ticker) {
    const ticker = (window as any).ticker as ITicker;
    const newTicker = {
      ...ticker,
      base: ticker.name.split('/')[0],
      quote: ticker.name.split('/')[1],
      base_precision: 2,
      new: true,
    };
    return newTicker;
  }
  return KTNState;
};

const defaultState = getDefaultState();

const currentReducer = (state = defaultState, action: any): ICurrentState => {
  switch (action.type) {
  case SWITCH:
    return { ...action.payload };
  default:
    return state;
  }
};

export default currentReducer;
